

















































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import validations from "@/plugins/validations";
import hasha from "hasha";
import {saveLogin, loginServer} from "@/plugins/utils/loginUtils";

@Component
export default class Login extends Vue {
  pass: string | null = null;
  username: string | null = null;
  rememberFlag = false;
  formValid = true;
  validations = validations;
  timeoutErro: number | null = null;

  loginAction(): boolean {
    this.toogleErrorMsg(false,null);
    const formValid = (this.$refs.loginForm as Vue & { validate: () => boolean }).validate();
    if(formValid){
      this.$store.commit("setLoading",true);
      const passTrans = hasha(this.pass as string);

      loginServer(
        this.username as string,
        passTrans,
        () => {
          if(this.rememberFlag){
            saveLogin(
              this.username as string,
              passTrans,
              (result: number | boolean) => {
                if(result){
                  this.$router.push("/dashboard");
                } else {
                  this.toogleErrorMsg(true, "Ocorreu um erro ao guardar os seus dados...");
                  if(this.timeoutErro){
                    clearTimeout(this.timeoutErro as number);
                  }
                  this.timeoutErro = null;
                  this.timeoutErro = window.setTimeout(() => {
                    this.$router.push("/dashboard");
                  },2000);
                }
                this.$store.commit("setLoading",false);
              }
            )
          }
          else{
            this.$router.push("/dashboard");
            this.$store.commit("setLoading",false);
          }
        },
        (code?: number) => {
          if(!code && code !== 0){
            this.toogleErrorMsg(true, "Ocorreu um erro... Tente de novo!");
          } else if(code == 0){
            this.toogleErrorMsg(true, "Ocorreu um erro de comunicação... Verifique a internet!");
          } else if(code == 401){
            this.toogleErrorMsg(true, "Dados de Login errados...");
          }
          this.$store.commit("setLoading",false);
        }
      );
    }
    return false;
  }

  toogleErrorMsg(flag: boolean, msg: null | string): void{
    if(msg){
      this.$store.commit("setError", {flag: flag, text: msg, status: "error"});
    }
    else{
      this.$store.commit("setError", {flag: flag, text: "", status: "error"});
    }
  }
}
